<template>
  <div ui-view="" class="app-body" id="view">
    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>IDC 입실 정보 확인</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>인적 사항 및 출입 기간 정보를 확인합니다.</p>
      </div>
    </div>

    <table class="tbl">
      <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
      <colgroup>
        <col width="120px">
        <col width="auto">
      </colgroup>
      <thead>
        <tr>
          <th></th>
          <th>CheckList</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            출입기간
          </td>
          <td>{{getDate(data.fromDate)}}~{{getDate(data.toDate)}}</td>
        </tr>
        <tr>
          <td>
            이름
          </td>
          <td>{{data.visitorName}}</td>
        </tr>
        <tr>
          <td>
            회사명
          </td>
          <td>{{data.visitorCompany}}</td>
        </tr>
        <tr>
          <td>
            이메일
          </td>
          <td>{{data.visitorMail}}</td>
        </tr>
        <tr>
          <td>
            방문목적
          </td>
          <td>{{getVisitTypeStr(data.changedVisitTypeCode ? data.changedVisitTypeCode : data.visitTypeCode)}}</td>
        </tr>
      </tbody>
    </table>
    <div class="box mt-20">
      <div class="box-header">
        <!-- 방문요청 신청자 정보 입력 -->
        <h3>반입 자산 확인</h3>
        <!-- 이름, 연락처, 이메일주소 등 방문 신청자 정보를 입력하세요. -->
        <p>반입 요청한 자산 정보를 확인합니다.</p>
      </div>
    </div>
    <table class="tbl">
      <!--<colgroup><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"><col width="16.66%"></colgroup>-->
      <colgroup>
        <col width="120px">
        <col width="auto">
        <col width="auto">
        <col width="auto">
        <col width="auto">
      </colgroup>
      <thead>
        <tr>
          <th>항목</th>
          <th>제조사</th>
          <th>모델명</th>
          <th>시리얼번호</th>
          <th>비고</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data.assetList" :key="index">
          <td class="ellipsis">{{item.visitorAssetCode.assetStr}}</td>
          <td class="ellipsis">{{item.assetManufacturer}}</td>
          <td class="ellipsis">{{item.assetModel}}</td>
          <td class="ellipsis">{{item.assetSerial}}</td>
          <td class="ellipsis">{{item.assetMemo}}</td>

        </tr>
      </tbody>
    </table>
    <div class="btn-wrap mt-30 mb-30 justify-content-center">

      <button class="btn btn-lg line-2" @click="prev()" v-if="showPrev"><i class="icon-arrow-line-left mr-5"></i>이전</button>
      <button class="btn btn-lg blue" @click="enter()" v-if="showNext" >확인<i class="icon-check  ml-5"></i></button>
    </div>
  </div>

</template>

<script>
import AgreeItem from '@/views/app/main/AgreeItem.vue';
export default {
  components: {AgreeItem },
  props: ['item', 'items', 'data', 'tos', 'checkList', 'visitTypeCode'],
  data(){
    return {
      checkItems:[

      ]
    }
  },
  computed: {
    getDate(){
      return (date) => {
        return moment(date).format('YYYY-MM-DD')
      }
    },
    showPrev() {
      return this.item.id <= 1 ? false : true;
    },
    showNext(){
      return this.item.id <= this.items.length
    },
    isCheckNext() {
      if(!this.checkItems)
        return false;
      return this.checkItems.filter((item)=>{return item.checked}).length != this.checkItems.length;
    },
  },
  mounted(){

    this.loadItems();
  },
  methods: {
    prev(){
      this.$emit('changeStep', {item: this.item, action: -1})
    },
    enter(){
      var that = this;
      var tos = this.tos.filter((x)=>x.isChecked).map((x)=>{return {tosIndex: x.tosIndex, isAgree:x.isChecked ? 1: 0}})

      var o = {tosList:tos, uuid: this.data.uuid, visitTypeCode: this.data.changedVisitTypeCode ? this.data.changedVisitTypeCode : this.data.visitTypeCode}

      this.$http.post('/api/private/visitor/enter', o)
        .then((result) => {
          this.closeModal();
          // this.$toast.success("입실 확인되었습니다.");
          this.noti('신청완료', '입실 신청이 완료되었습니다.', 'success');
          this.$router.push('qrScan');
        }).catch((e) =>{
      })

    },
    getQuery(){
      var query = Object.assign({},this.$route.query);
      var tosList = this.checkItems.filter((item)=>{return item.isChecked});
            query.tos = JSON.stringify(_.chain(tosList)
      .keyBy('tosIndex')
      .mapValues('isChecked')
      .value());
      return query;
    },
    loadItems(){
      var that = this;
      this.$http.get('/api/public/checkList/2')
        .then((result) => {

          result.data.forEach((item) => {
            item.isChecked = false;
          });

          that.checkItems = result.data;
        }).catch((e) =>{
      })
    },
    checkAllHandler(){
      this.checkItems.forEach((item)=>{
        item.isChecked = !item.isChecked ;
      })
    },
    agreeCheckHandler(data){
      var that = this;
      this.checkItems.forEach((item)=>{
        if(data.tosIndex == item.tosIndex) {
          item.isChecked = data.isChecked;
          return;
        }
      })
    },
    getVisitTypeStr(visitTypeCode){
      let filtered = this.$store.getters["dropdown/dataprovider"].visitType.filter(typeObj => typeObj.visitTypeCode == visitTypeCode);
      debugger;
      return filtered[0] ? filtered[0].visitTypeStr : '';
    }
  }
}
</script>

<style>

